// @ts-nocheck
import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
	name: 'checkDateRules',
})
export class CheckDateRulesPipe implements PipeTransform {
	transform(
		day: moment.Moment,
		rules,
		disabledDateRules,
		args: Record<string, number | Array<string>>,
	): boolean {
		const { min = 0, max = 0, holidays = null, minValue = 0, maxValue = 0 } = args;
		if (!day || (!rules && !disabledDateRules)) {
			return false;
		}
		// Se esse método retornar false é pq alguma regra não passou
		const today = moment().format('YYYY-MM-DD'); // pega a data d o dia atual
		const resp: { details: string[]; error: boolean; params: any[] } = {
			details: [],
			error: false,
			params: [],
		};
		try {
			resp.details = [];
			resp.error = false;

			if (Array.isArray(rules)) {
				rules.forEach((rule) => {
					/* Loop nas regras */
					switch (
						rule // verifica regras
					) {
						case 'du>=d':
							if (!moment(day).isAfter(today) && !moment(day).isSame(today)) {
								resp.details.push('A data informada deve ser igual ou maior que a data de hoje');
								resp.error = true;
							}
							break;
						case 'du>d':
							if (!moment(day).isAfter(today)) {
								resp.details.push('A data informada deve ser maior que a data de hoje');
								resp.error = true;
							}
							break;
						case 'du<=d':
							if (!moment(day).isBefore(today) && !moment(day).isSame(today)) {
								resp.details.push('A data informada deve ser igual ou menor que a data de hoje');
								resp.error = true;
							}
							break;
						case 'du<d':
							if (!moment(day).isBefore(today)) {
								resp.details.push('A data informada deve ser menor que a data de hoje');
								resp.error = true;
							}
							break;
						case 'du>=mn':
							if (
								min &&
								typeof min === 'number' &&
								!moment(day).isAfter(moment.unix(min)) &&
								!moment(day).isSame(moment.unix(min))
							) {
								resp.details.push('A data informada deve ser igual ou maior que a data mínima');
								resp.error = true;
							}
							break;
						case 'du>mn':
							if (typeof min === 'number' && !moment(day).isAfter(moment.unix(min))) {
								resp.details.push('A data informada deve ser maior que a data mínima');
								resp.error = true;
							}
							break;
						case 'du<=mx':
							if (
								typeof max === 'number' &&
								max &&
								!moment(day).isBefore(moment.unix(max)) &&
								!moment(day).isSame(moment.unix(max))
							) {
								resp.details.push('A data informada deve ser igual ou menor que a data máxima');
								resp.error = true;
							}
							break;
						case 'du<mx':
							if (max && typeof max === 'number' && !moment(day).isBefore(moment.unix(max))) {
								resp.details.push('A data informada deve ser menor que a data máxima');
								resp.error = true;
							}
							break;
						default:
						// console.warn("invalid rule");
					}
				});
			}

			if (Array.isArray(disabledDateRules)) {
				disabledDateRules.forEach((disabledDateRule: any) => {
					let applyRule = false;
					const { conditions = {} } = disabledDateRule;

					const ops = {
						gte: (value) => moment().isSameOrAfter(value),
						gt: (value) => moment().isAfter(value),
						lte: (value) => moment().isSameOrBefore(value),
						lt: (value) => moment().isBefore(value),
					};

					const types = {
						time: (op, value) => ops[op](moment(value, 'hh:mm')),
					};

					if (Array.isArray(conditions?.or)) {
						const orRulesSatisfied = conditions.or.filter((orRule) =>
							types[orRule.type](orRule.op, orRule[orRule.type]),
						);
						applyRule = orRulesSatisfied.length === conditions.or.length;
					}

					if (Array.isArray(conditions?.and)) {
						const andRulesSatisfied = conditions.and.filter((andRule) =>
							types[andRule.type](andRule.op, andRule[andRule.type]),
						);
						applyRule = andRulesSatisfied.length === conditions.and.length;
					}

					if (conditions?.always) applyRule = true;

					if (applyRule) {
						switch (disabledDateRule.rule) {
							case 'sunday':
								if (day.isoWeekday() === 7) {
									resp.details.push('A data informada não pode ser um domingo');
									resp.error = true;
								}
								break;
							case 'saturday':
								if (day.isoWeekday() === 6) {
									resp.details.push('A data informada não pode ser um sábado');
									resp.error = true;
								}
								break;
							case 'holidays':
								if (Array.isArray(holidays) && holidays.includes(day.format('DD/MM'))) {
									resp.details.push('A data informada não pode ser um feriado nacional');
									resp.error = true;
								}
								break;
							case 'nextBusinessday':
								// eslint-disable-next-line no-case-declarations
								let current = moment(day.format('DDMMYYYY'), 'DDMMYYYY');
								for (let index = 0; index < disabledDateRule.quantity || index > 100; ) {
									current = current.subtract(1, 'days');
									if (
										Array.isArray(holidays) &&
										!(
											current.isoWeekday() === 7 ||
											current.isoWeekday() === 6 ||
											holidays.includes(current.format('DD/MM'))
										)
									) {
										index++;
									}
								}

								if (moment(current).isBefore(today) || moment(current).isSame(today)) {
									resp.details.push(
										`A data informada deve ser posterior ao(s) próximo(s) ${disabledDateRule.quantity} dia(s) útil(eis)`,
									);
									resp.error = true;
								}
								break;
							case 'lt':
								if (day.isBefore(moment().startOf('day'))) {
									resp.details.push('A data informada deve ser posterior a data atual');
									resp.error = true;
								}
								break;
							case 'lte':
								if (day.isSameOrBefore(moment().endOf('day'))) {
									resp.details.push('A data informada deve ser posterior ou igual a data atual');
									resp.error = true;
								}
								break;
							case 'gt':
								if (day.isAfter(moment().endOf('day'))) {
									resp.details.push('A data informada deve ser anterior a data atual');
									resp.error = true;
								}
								break;
							case 'gte':
								if (day.isSameOrAfter(moment().startOf('day'))) {
									resp.details.push('A data informada deve ser anterior ou igual a data atual');
									resp.error = true;
								}
								break;
							case 'ltmn':
								if (
									typeof minValue === 'number' &&
									day.isBefore(moment.unix(minValue).startOf('day'))
								) {
									resp.details.push(
										'A data informada deve ser posterior ou igual a ' +
											moment.unix(minValue).format('DD/MM'),
									);
									resp.error = true;
								}
								break;
							case 'ltemn':
								if (
									typeof minValue === 'number' &&
									day.isSameOrBefore(moment.unix(minValue).endOf('day'))
								) {
									resp.details.push(
										'A data informada deve ser posterior a ' +
											moment.unix(minValue).format('DD/MM'),
									);
									resp.error = true;
								}
								break;
							case 'gtmx':
								if (
									typeof maxValue === 'number' &&
									day.isAfter(moment.unix(maxValue).endOf('day'))
								) {
									resp.details.push(
										'A data informada deve ser anterior ou igual a ' +
											moment.unix(maxValue).format('DD/MM'),
									);
									resp.error = true;
								}
								break;
							case 'gtemx':
								if (
									typeof maxValue === 'number' &&
									day.isSameOrAfter(moment.unix(maxValue).startOf('day'))
								) {
									resp.details.push(
										'A data informada deve ser anterior a ' + moment.unix(maxValue).format('DD/MM'),
									);
									resp.error = true;
								}
								break;
							default:
								console.warn('invalid rule');
						}
					}
				});
			}
		} catch (e) {
			resp.details = ['Não há regras de data'];
			resp.error = false;
		}
		return resp.error;
	}
}
